export default __webpack_public_path__ + "static/media/bluetick.afdef76e.jpeg";